export default {
    'female': 'Kobieta',
    'language': 'Język',
    'male': 'Mężczyzna',
    'recording-type': 'Rodzaj nagrania',
    'sex': 'Płeć'
}
